import React from 'react';
import { FileText, ChevronRight } from 'lucide-react';
import { mockCandidates } from '../../utils/mockData';
import { Candidate } from '../../types/hr.types';
interface WaitingOnResponseWidgetProps {
  onCandidateClick?: (candidate: Candidate) => void;
}
export function WaitingOnResponseWidget({
  onCandidateClick
}: WaitingOnResponseWidgetProps) {
  const candidates = mockCandidates.filter(c => c.status === 'Waiting on Response' || c.status === 'Offer Sent');
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col h-full" data-id="element-1690">
      <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between bg-orange-50/50" data-id="element-1691">
        <div className="flex items-center gap-2" data-id="element-1692">
          <div className="p-1.5 rounded-lg bg-orange-100" data-id="element-1693">
            <FileText className="h-5 w-5 text-orange-600" data-id="element-1694" />
          </div>
          <h3 className="font-semibold text-gray-900" data-id="element-1695">Pending Offers</h3>
        </div>
        <span className="bg-white text-gray-700 text-xs font-bold px-2.5 py-1 rounded-full shadow-sm border border-gray-100" data-id="element-1696">
          {candidates.length}
        </span>
      </div>
      <div className="p-4 flex-1 overflow-y-auto" data-id="element-1697">
        {candidates.length > 0 ? <div className="space-y-3" data-id="element-1698">
            {candidates.map(candidate => <div key={candidate.id} onClick={() => onCandidateClick?.(candidate)} className="group relative flex items-center justify-between p-3 rounded-xl bg-white border border-gray-100 shadow-sm hover:shadow-md hover:border-orange-100 transition-all duration-200 cursor-pointer" data-id="element-1699">
                <div className="flex items-center gap-3 min-w-0" data-id="element-1700">
                  <div className="h-10 w-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 font-medium border border-gray-200 flex-shrink-0" data-id="element-1701">
                    {candidate.firstName[0]}
                    {candidate.lastName[0]}
                  </div>
                  <div className="min-w-0" data-id="element-1702">
                    <p className="text-sm font-semibold text-gray-900 truncate group-hover:text-orange-700 transition-colors" data-id="element-1703">
                      {candidate.firstName} {candidate.lastName}
                    </p>
                    <p className="text-xs text-gray-500 truncate" data-id="element-1704">
                      {candidate.role} • Offered {candidate.offerSentDate}
                    </p>
                  </div>
                </div>
                <ChevronRight className="h-4 w-4 text-gray-400 group-hover:text-orange-600 transition-colors flex-shrink-0" data-id="element-1705" />
              </div>)}
          </div> : <div className="h-full flex flex-col items-center justify-center text-center py-6" data-id="element-1706">
            <div className="h-12 w-12 rounded-full bg-gray-50 flex items-center justify-center mb-3" data-id="element-1707">
              <FileText className="h-6 w-6 text-gray-400" data-id="element-1708" />
            </div>
            <p className="text-sm font-medium text-gray-900" data-id="element-1709">
              No pending offers
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-1710">
              All offers have been responded to.
            </p>
          </div>}
      </div>
    </div>;
}